// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b5d57b04","977":"c8ecb433"}[chunkId] + ".chunk.js";
};